"use strict";
/**
 * 首页
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHome = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
var title_1 = require("./shared/title");
var layout_1 = require("./shared/layout");
var tab_quote_chart_1 = require("./shared/tab_quote_chart");
var title_bar_1 = require("./shared/title_bar");
var home_custom_1 = require("./shared/home/home_custom");
var home_rzrq_1 = require("./shared/home/home_rzrq");
var zixun_1 = require("./shared/zixun");
var quote_1 = require("./shared/quote");
var home_box_1 = require("./shared/home/home_box");
var refresh_1 = require("../refresh");
var mini_time_chart_1 = require("./shared/mini_time_chart");
require("./home.less");
var loadtimestat_1 = __importDefault(require("../../modules/loadtimestat"));
var user_1 = __importDefault(require("../../modules/user"));
var axios_1 = __importDefault(require("axios"));
var dayjs_1 = __importDefault(require("dayjs"));
var react_dom_1 = __importDefault(require("react-dom"));
var send_1 = require("../../modules/stat/send");
var thisuser = user_1.default.get();
/**
 * 首页
 * @returns
 */
function PageHome() {
    (0, react_1.useEffect)(function () {
        (0, loadtimestat_1.default)();
    }, []);
    // let [mounted,setMounted] = useState(false)
    // useEffect(()=>{
    //   setMounted(true)
    //   loadTimeSata()
    // },[])
    // if(!mounted) return<></>
    /**
     * 恢复默认
     */
    var reSet = function () {
        localStorage.removeItem("qjt-timechart-1");
        localStorage.removeItem("qjt-timechart-2");
        localStorage.removeItem("qjt-timechart-3");
        self.location.reload();
    };
    return (react_1.default.createElement("div", { className: "pagehome" },
        react_1.default.createElement(crumbs_1.Crumbs, null),
        react_1.default.createElement(title_1.Title1, null,
            react_1.default.createElement(title_1.Title1.Main, null,
                react_1.default.createElement(react_1.default.Fragment, null,
                    "\u5168\u666F\u56FE",
                    react_1.default.createElement(QuoteCenterMiaoTG, null))),
            react_1.default.createElement(title_1.Title1.More, null,
                react_1.default.createElement(refresh_1.RefreshBtn, null),
                ' ',
                react_1.default.createElement("a", { className: "re_set", onClick: reSet },
                    react_1.default.createElement("em", { className: "icon_undo" }),
                    "\u6062\u590D\u9ED8\u8BA4"))),
        react_1.default.createElement(layout_1.Layout4, { mt: 10 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(QuanJingTuCharts, { localstorgekey: "qjt-timechart-1", data: [
                        {
                            title: '上证指数',
                            quotecode: '1.000001',
                        },
                        {
                            title: '沪深300',
                            quotecode: '1.000300',
                        },
                        {
                            title: '上证50',
                            quotecode: '1.000016',
                        },
                        {
                            title: 'B股指数',
                            quotecode: '1.000003',
                        },
                        {
                            title: '科创综指',
                            quotecode: '1.000680',
                        },
                    ] })),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(QuanJingTuCharts, { localstorgekey: "qjt-timechart-2", data: [
                        {
                            title: '深证成指',
                            quotecode: '0.399001',
                        },
                        {
                            title: '创业板',
                            quotecode: '0.399006',
                        },
                        {
                            title: '深证综指',
                            quotecode: '0.399106',
                        },
                        {
                            title: '成份B指',
                            quotecode: '0.399003',
                        }
                    ] })),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(QuanJingTuCharts, { localstorgekey: "qjt-timechart-3", data: [
                        {
                            title: '期指',
                            quotecode: '8.040120',
                        },
                        {
                            title: '恒指',
                            quotecode: '100.HSI',
                        },
                        {
                            title: '道指',
                            quotecode: '100.DJIA',
                        },
                        {
                            title: '日经',
                            quotecode: '100.N225',
                        },
                        {
                            title: '美元',
                            quotecode: '100.UDI',
                        },
                        {
                            title: '黄金',
                            quotecode: thisuser == null ? '113.aum' : '101.GC00Y',
                        },
                        {
                            title: '原油',
                            quotecode: '102.CL00Y',
                        },
                        {
                            title: '离岸',
                            quotecode: '133.USDCNH',
                        },
                    ] })),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(CustomChart, null))),
        react_1.default.createElement(title_bar_1.TitleBar, { mt: 10 },
            react_1.default.createElement(title_bar_1.TitleBar.Title, null,
                react_1.default.createElement("a", { href: "https://kuaixun.eastmoney.com/" }, "\u6700\u65B0\u6D88\u606F")),
            react_1.default.createElement(title_bar_1.TitleBar.Content, null,
                react_1.default.createElement(zixun_1.LastNewsScroll, null))),
        react_1.default.createElement(layout_1.Layout4, { mt: 10 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(home_box_1.HomeBox1_1, null)),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(home_box_1.HomeBox1_2, null)),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(home_box_1.HomeBox1_3, null)),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(home_box_1.HomeBox1_4, null))),
        react_1.default.createElement(title_bar_1.TitleBar, { mt: 10 },
            react_1.default.createElement(title_bar_1.TitleBar.Title, null,
                react_1.default.createElement("a", { href: "https://quote.eastmoney.com/changes" }, "\u76D8\u53E3\u5F02\u52A8")),
            react_1.default.createElement(title_bar_1.TitleBar.Content, null,
                react_1.default.createElement(quote_1.LastPKYDScroll, null))),
        react_1.default.createElement(home_custom_1.HomeCustom, null),
        react_1.default.createElement(home_rzrq_1.HomeRZRQ, null)));
}
exports.PageHome = PageHome;
/**
 * tab 自定义分时图
 * @param props
 * @returns
 */
function QuanJingTuCharts(props) {
    var _a = (0, react_1.useState)(0), curIndex = _a[0], setCurIndex = _a[1];
    (0, react_1.useEffect)(function () {
        var tabindex = localStorage.getItem(props.localstorgekey) || 0;
        setCurIndex(Number(tabindex));
    }, []);
    var changeTab = function (index) {
        if (index === void 0) { index = 0; }
        localStorage.setItem(props.localstorgekey, String(index));
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(tab_quote_chart_1.TabQuoteTimeChart, { data: props.data, defaultindex: curIndex, changeTabCallback: changeTab }));
}
/**
 * 自定义分时模块
 */
function CustomChart() {
    var cuscode = localStorage.getItem("customstock-timechart") || '0.300059';
    var _a = (0, react_1.useState)(cuscode), customStock = _a[0], setCustomStock = _a[1];
    (0, react_1.useEffect)(function () {
        if (window.suggest2017) {
            new suggest2017({
                inputid: 'custom-chart',
                placeholder: '输入股票代码、名称或简称',
                width: 280,
                stockcount: 8,
                showstocklink: false,
                showblank: false,
                position: {
                    left: -60,
                    top: 0
                },
                modules: ["stock"],
                onConfirmStock: 'submit',
                onSubmit: function (res) {
                    var _a;
                    if ((_a = res === null || res === void 0 ? void 0 : res.stock) === null || _a === void 0 ? void 0 : _a.Code) {
                        var quotecode = "".concat(res.stock.MktNum, ".").concat(res.stock.Code);
                        setCustomStock(quotecode);
                        localStorage.setItem("customstock-timechart", quotecode);
                    }
                    return false;
                }
            });
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "custom_chart_wrap" },
            react_1.default.createElement("div", { className: "c_head" },
                react_1.default.createElement("form", null,
                    react_1.default.createElement("input", { id: "custom-chart", type: "text", className: "txt_search" }),
                    react_1.default.createElement("input", { type: "submit", className: "btn_search", value: "\u8BBE\u7F6E\u5206\u65F6\u56FE" }))),
            react_1.default.createElement("div", { className: "minchart" },
                react_1.default.createElement(mini_time_chart_1.MiniTimeChart, { quotecode: customStock, height: 180, key: customStock })))));
}
/**
 * 首页 妙想 全景图 推广
 * @returns
 */
function QuoteCenterMiaoTG() {
    var _this = this;
    var _a = (0, react_1.useState)([]), data = _a[0], setData = _a[1];
    var _b = (0, react_1.useState)(false), showtg = _b[0], setShowTG = _b[1];
    var getNumber = (0, react_1.useMemo)(function () {
        return Math.floor(Math.random() * data.length);
    }, [data]);
    var getData = function () { return __awaiter(_this, void 0, void 0, function () {
        var back;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getMiaoXiangTGData()];
                case 1:
                    back = _a.sent();
                    if (back) {
                        setData(back.map(function (v) { return v.question; }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getData();
    }, []);
    if (data.length === 0)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "t_tg miao_tg" },
        react_1.default.createElement("div", { onClick: function () { setShowTG(true); } }, 
        //取出data的随机一条
        data[getNumber]),
        showtg && react_1.default.createElement(MiaoXiangPop, { onClose: function () { setShowTG(false); } })));
}
/**
 * 获取妙想推广数据
 */
function getMiaoXiangTGData() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var tg, tgData, uid, back, data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    tg = localStorage.getItem('miaoxiang_tg');
                    if (tg) {
                        tgData = JSON.parse(tg);
                        //判断缓存是否有效，有效期一天
                        if ((0, dayjs_1.default)().diff((0, dayjs_1.default)(tgData.date), 'days') < 1)
                            return [2 /*return*/, tgData.data || []];
                    }
                    uid = thisuser ? thisuser.id : '';
                    return [4 /*yield*/, (0, axios_1.default)("https://eminterservice.securities.eastmoney.com/api/recommend/mxQuestionFeed?entranceCode=web_stock_overview&client=web&uid=".concat(uid))];
                case 1:
                    back = _e.sent();
                    data = (_b = (_a = back === null || back === void 0 ? void 0 : back.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.questions;
                    //写入localstorage缓存，有效期一天
                    localStorage.setItem('miaoxiang_tg', JSON.stringify({
                        date: (0, dayjs_1.default)().format('YYYY-MM-DD'),
                        data: data
                    }));
                    return [2 /*return*/, ((_d = (_c = back === null || back === void 0 ? void 0 : back.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.questions) || []];
            }
        });
    });
}
var ggimgurl_cache = '';
/**
 * 妙想推广弹窗
 */
function MiaoXiangPop(props) {
    var _this = this;
    var thisimgdiv = (0, react_1.useRef)(null);
    var thisimg = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(ggimgurl_cache), ggimgurl = _a[0], setGgImgUrl = _a[1];
    var close = function () {
        props.onClose();
    };
    //获取广告图片
    var getTGImg = function () { return __awaiter(_this, void 0, void 0, function () {
        var options, back;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (ggimgurl != '')
                        return [2 /*return*/];
                    options = {
                        method: 'GET',
                        url: '/center/api/miaoxiang_tg'
                    };
                    return [4 /*yield*/, (0, axios_1.default)(options)];
                case 1:
                    back = _d.sent();
                    if (((_c = (_b = (_a = back === null || back === void 0 ? void 0 : back.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.adPositionData) === null || _c === void 0 ? void 0 : _c.list) instanceof Array && back.data.data.adPositionData.list.length > 0 && back.data.data.adPositionData.list[0].imgUrl instanceof Array && back.data.data.adPositionData.list[0].imgUrl.length > 0) {
                        setGgImgUrl(back.data.data.adPositionData.list[0].imgUrl[0]);
                        ggimgurl_cache = back.data.data.adPositionData.list[0].imgUrl[0];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getTGImg();
        //大数据统计
        (0, send_1.sendStat)('Div', 'Click', 'hangqingCenterHome.wholeMap.guideAdClick');
    }, []);
    var imgonload = function () {
        // console.info('触发img onload')
        if (thisimg.current && thisimgdiv.current) {
            var img = thisimg.current;
            var imgdiv = thisimgdiv.current;
            //图片加载完成后再计算大小
            //调整div的位置
            imgdiv.style.marginLeft = '-' + (img.naturalWidth / 4) + 'px';
            imgdiv.style.marginTop = '-' + (img.naturalHeight / 4) + 'px';
            // 按照等比例缩放一半
            img.style.width = img.naturalWidth / 2 + 'px';
            img.style.height = img.naturalHeight / 2 + 'px';
            img.style.visibility = 'visible';
            document.body.querySelector('.mxpoptg_closeimg').style.visibility = 'visible';
        }
    };
    //获取图片实际大小
    // useEffect(()=>{
    //   // if(ggimgurl == '') return
    // }, [ggimgurl])
    var pop = (react_1.default.createElement("div", { className: "mxpoptg" },
        react_1.default.createElement("div", { className: "mxpoptg_img", ref: thisimgdiv },
            react_1.default.createElement("img", { className: "mxpoptg_img_i", src: ggimgurl, alt: "", ref: thisimg, onLoad: imgonload }),
            react_1.default.createElement("div", { className: "mxpoptg_close", onClick: close }),
            react_1.default.createElement("img", { src: "https://emcharts.dfcfw.com/fullscreengg/ic_close.png", alt: "", className: "mxpoptg_closeimg", onClick: close }))));
    return react_dom_1.default.createPortal(pop, document.body);
}
